var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19.818 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.817 15.244a8.464 8.464 0 0 1-4.427 1.239A8.317 8.317 0 0 1 0 8.242 8.318 8.318 0 0 1 8.391 0a8.318 8.318 0 0 1 8.392 8.242 8.131 8.131 0 0 1-2.083 5.435l5.12 5.687L18 21l-5.183-5.756Zm-4.426-.867a6.2 6.2 0 0 0 6.25-6.138A6.2 6.2 0 0 0 8.391 2.1a6.2 6.2 0 0 0-6.25 6.139 6.2 6.2 0 0 0 6.25 6.138Z",
  fill: "currentColor",
  fillRule: "evenodd"
})));

export default SvgSearch;